import React, { useState } from "react";
import { COLORS } from "../theme";

interface FireButtonProps {
    onClick?: () => void;
}

const FireButton: React.FC<FireButtonProps> = ({ onClick }) => {
    const [cursorPosition, setCursorPosition] = useState({ x: 0 });
    const [gradientOpacity, setGradientOpacity] = useState({ left: 1, right: 0 });

    const handleMouseMove = (e: React.MouseEvent<HTMLButtonElement>) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const x = e.clientX - rect.left;

        setCursorPosition({ x });

        // Calculate gradient opacity based on cursor position
        const leftOpacity = Math.max(0, Math.min(1, 1 - x / (rect.width / 2)));
        const rightOpacity = Math.max(
            0,
            Math.min(1, (x - rect.width / 2) / (rect.width / 2))
        );

        setGradientOpacity({ left: leftOpacity, right: rightOpacity });
    };

    const handleMouseLeave = () => {
        const timeoutId = setTimeout(() => {
            setCursorPosition({ x: 0 });
            setGradientOpacity({ left: 1, right: 0 });

            // Clear the timeout after it executes
            clearTimeout(timeoutId);
        }, 3000);
    };

    return (
        <button
            style={{
                position: 'relative',
                borderRadius: '9999px',
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                maxWidth: '300px',
                color: 'black',
                border: '2px solid #5B21B6',
                background: 'transparent',
                cursor: 'pointer'
                // color: COLORS.background
            }}
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
            onClick={onClick}
        >
            {/* Left gradient */}
            <div
                style={{
                    opacity: gradientOpacity.left,
                    position: 'absolute',
                    left: '-8px',
                    height: '125%',
                    width: '50%',
                    background: 'linear-gradient(to right, #ea580c, transparent)',
                    filter: 'blur(4px)',
                    borderRadius: '9999px',
                    pointerEvents: 'none',
                    transition: 'opacity 100ms'
                }}
            />
            <div
                style={{
                    opacity: gradientOpacity.left,
                    position: 'absolute',
                    left: '-8px',
                    height: '125%',
                    width: '40%',
                    background: 'linear-gradient(to right, #ea580c, transparent)',
                    filter: 'blur(4px)',
                    borderRadius: '9999px',
                    pointerEvents: 'none',
                    transition: 'opacity 100ms'
                }}
            />

            {/* Right gradient */}
            <div
                style={{
                    opacity: gradientOpacity.right,
                    position: 'absolute',
                    right: '-8px',
                    height: '125%',
                    width: '50%',
                    background: 'linear-gradient(to left, #ea580c, transparent)',
                    filter: 'blur(4px)',
                    borderRadius: '9999px',
                    pointerEvents: 'none',
                    transition: 'opacity 100ms'
                }}
            />
            <div
                style={{
                    opacity: gradientOpacity.right,
                    position: 'absolute',
                    right: '-8px',
                    height: '125%',
                    width: '40%',
                    background: 'linear-gradient(to left, #ea580c, transparent)',
                    filter: 'blur(4px)',
                    borderRadius: '9999px',
                    pointerEvents: 'none',
                    transition: 'opacity 100ms'
                }}
            />

            <div style={{
                position: 'relative',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                border: '1px solid #5B21B6',
                background: '#8B5CF6',
                width: '100%',
                padding: '16px 0',
                borderRadius: '9999px',
                overflow: 'hidden'
            }}>
                <div
                    style={{
                        position: 'absolute',
                        display: 'flex',
                        width: '204px',
                        height: '103px',
                        alignItems: 'center',
                        justifyContent: 'center',
                        pointerEvents: 'none',
                        left: `${cursorPosition.x - 102}px`,
                        transition: 'left 300ms cubic-bezier(0.4, 0, 0.2, 1)'
                    }}
                >
                    <div style={{
                        position: 'absolute',
                        height: '100%',
                        width: '100%',
                        background: 'radial-gradient(43.3% 44.23% at 50% 49.51%, #FFFF00 29%, #FFD700 48.5%, #FFA500 60.71%, rgba(214,211,210,0.00) 100%)',
                        filter: 'blur(12px)'
                    }} />
                </div>
                <p style={{
                    fontSize: '24px',
                    fontWeight: '600',
                    zIndex: 10,
                    margin: 0
                }}>Demo</p>
            </div>
        </button>
    );
};

export default FireButton; 